import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { Button, Col, Row } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { ProductContext } from 'context/Context';
import QuantityController from '../QuantityController';
import { useProductHook } from 'hooks/useProductHook';
import { changeToCoin } from 'helpers/utils';
import Flex from 'components/common/Flex';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const CartItem = ({ product }) => {
 const { _id, image, name, references, quantity, totalPrice } = product;

 const { handleAddToCart } = useProductHook(product);

 const { productsDispatch } = useContext(ProductContext);

 const handleRemove = () => {
  productsDispatch({
   type: 'REMOVE_FROM_CART',
   payload: {
    product
   }
  });
 };

 const handleIncrease = () => {
  handleAddToCart(parseInt(quantity + 1), false, false, references);
 };

 const handleDecrease = () => {
  if (quantity > 1) {
   handleAddToCart(parseInt(quantity - 1), false, false, references);
  }
 };

 const handleChange = e => {
  handleAddToCart(parseInt(e.target.value < 1 ? 1 : e.target.value), false, false, references);
 };

 return (
  <Row className="gx-card mx-0 align-items-center border-bottom border-200">
   <Col xs={8} className="py-3">
    <div className="d-flex align-items-center">
     <Link to={`/products/details/${_id}`}>
      <img
       src={
        references?.reduce((acc, e) => {
         if (e.images.length) acc = e.images[0];
         return acc;
        }, '') || image[0]
       }
       width="60"
       alt={name}
       className="img-fluid rounded-1 me-3 d-none d-md-block"
      />
     </Link>
     <div className="flex-1">
      <h5 className="fs-1 mb-0">
       <Link to={`/products/details/${_id}`} className="text-900">
        {name}
       </Link>
      </h5>
      <div className="fs--1 d-flex">
       {references.map((e, i) => (
        <Flex key={i} className="flex-fill" alignItems="center" wrap="nowrap" justifyContent="start">
         <span className="me-3">{e.ref}: </span>
         {e?.color ? <FontAwesomeIcon icon="circle" className="" transform="shrink-3" style={{ color: e.color }} /> : <></>}
         <span className="">{e.name.toLowerCase()}</span>
        </Flex>
       ))}
      </div>
      <div className="">
       <Button variant="link" size="sm" className="text-danger fs--1 fw-normal p-0" onClick={() => handleRemove(_id)}>
        Remove
       </Button>
      </div>
     </div>
    </div>
   </Col>
   <Col xs={4} className="py-3">
    <Row className="align-items-center">
     <Col md={{ span: 8, order: 0 }} xs={{ order: 1 }} className="d-flex justify-content-end justify-content-md-center">
      <div>
       <QuantityController
        quantity={quantity}
        handleChange={handleChange}
        handleIncrease={handleIncrease}
        handleDecrease={handleDecrease}
        btnClassName="px-2"
       />
      </div>
     </Col>
     <Col md={{ span: 4, order: 1 }} xs={{ order: 0 }} className="text-end ps-0 mb-2 mb-md-0 text-600">
      {changeToCoin({ amount: totalPrice, symbol: true, cents: true })}
     </Col>
    </Row>
   </Col>
  </Row>
 );
};

CartItem.propTypes = {
 product: PropTypes.shape({
  _id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
  image: PropTypes.array.isRequired,
  name: PropTypes.string.isRequired,
  quantity: PropTypes.number.isRequired,
  totalPrice: PropTypes.number.isRequired,
  references: PropTypes.array.isRequired
 })
};

export default CartItem;
